import tour1 from "./images/tour-1.jpeg";
import tour2 from "./images/tour-2.jpeg";
import tour3 from "./images/tour-3.jpeg";
import tour4 from "./images/tour-4.jpeg";

export const pageLinks = [
  { id: 1, href: "#home", text: "home" },
  { id: 2, href: "#about", text: "about" },
  { id: 3, href: "#services", text: "services" },
  { id: 4, href: "#tours", text: "tours" },
];

export const socialLinks = [
  {
    id: 1,
    href: "https://www.twitter.com",
    icon: "fab fa-facebook",
  },
  {
    id: 1,
    href: "https://www.twitter.com",
    icon: "fab fa-twitter",
  },
  {
    id: 1,
    href: "https://www.twitter.com",
    icon: "fab fa-squarespace",
  },
];

export const tours = [
  {
    id: 1,
    image: tour1,
    date: "August 26th, 2020",
    title: "Tibet Adventure",
    info: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quodex ercitationem fugit, qui corporis.",
    location: "China",
    duration: 6,
    price: 2100,
  },
  {
    id: 2,
    image: tour2,
    date: "October 1th, 2020",
    title: "Best of Java",
    info: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quodex ercitationem fugit, qui corporis.",
    location: "Indonesia",
    duration: 11,
    price: 1400,
  },
  {
    id: 3,
    image: tour3,
    date: "September 15th, 2020",
    title: "Explore Hong Kong",
    info: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quodex ercitationem fugit, qui corporis.",
    location: "Hong Kong",
    duration: 8,
    price: 5000,
  },
  {
    id: 4,
    image: tour4,
    date: "December 5th, 2019",
    title: "Kenya Highlights",
    info: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quodex ercitationem fugit, qui corporis.",
    location: "Kenya",
    duration: 20,
    price: 3300,
  },
];
